import {
    FETCH_SERVICES_REQUEST, FETCH_SERVICES_SUCCESS, FETCH_SERVICES_FAILURE,
    CREATE_SERVICE_SUCCESS, UPDATE_SERVICE_SUCCESS, DELETE_SERVICE_SUCCESS
  } from '../actions/serviceActions';
  
  const initialState = {
    services: [],
    loading: false,
    error: null,
  };
  
  export default function serviceReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_SERVICES_REQUEST:
        return { ...state, loading: true };
      case FETCH_SERVICES_SUCCESS:
        return { ...state, loading: false, services: action.payload };
      case FETCH_SERVICES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_SERVICE_SUCCESS:
        return { ...state, services: [...state.services, action.payload] };
      case UPDATE_SERVICE_SUCCESS:
        return {
          ...state,
          services: state.services.map((service) =>
            service.id === action.payload.id ? action.payload : service
          ),
        };
      case DELETE_SERVICE_SUCCESS:
        return {
          ...state,
          services: state.services.filter((service) => service.id !== action.payload),
        };
      default:
        return state;
    }
  }
  